/* Copyright 2021, Milkdown by Mirone. */
import { injectVar, pack2Tool } from '@milkdown/design-system';
import { createSlice } from '../context';
export const themeToolCtx = createSlice({
    mixin: {},
    font: {},
    size: {},
    slots: {},
    palette: () => '',
}, 'ThemeTool');
export const themeFactory = (themePack) => (pre) => {
    pre.inject(themeToolCtx);
    return (ctx) => {
        injectVar(themePack);
        const tool = pack2Tool(themePack);
        ctx.set(themeToolCtx, tool);
    };
};
//# sourceMappingURL=theme.js.map